export default {
  topMenu: {
    'openSettings': 'Abrir la configuración',
    'showAbout': 'Mostrar información general',
    'about': 'Acerca de ORS',
    'pinSidebar': 'Fijar la barra lateral',
    'settingsTooltip': 'Haga clic aquí si desea ajustar la configuración de la aplicación'
  }
}
